import Siema from 'siema'

const quoteSliders = [...document.querySelectorAll('.js-quoteSlider')]

if (quoteSliders.length > 0) {
    quoteSliders.forEach(function applyQuoteSlider (quoteSlider) {
        const photoSlider = quoteSlider.querySelector('.js-photoSlider')
        const textSlider = quoteSlider.querySelector('.js-textSlider')
        const nextButton = quoteSlider.querySelector('.js-next')
        const prevButton = quoteSlider.querySelector('.js-previous')
        const slideButtons = [...quoteSlider.querySelectorAll('.js-slide')]
        const slideCount = quoteSlider.dataset.slideLength * 1

        const photoSliderInstance = new Siema({
            selector: photoSlider,
            duration: 1000,
            easing: 'cubic-bezier(.17,.67,0,.96)',
        })

        const textSliderInstance = new Siema({
            selector: textSlider,
            duration: 750,
            easing: 'cubic-bezier(.17,.67,0,.96)',
            onChange: () => {
                const index = textSliderInstance.currentSlide
                slideButtons.forEach(button => button.classList.remove('-active'))

                if (index === 0) {
                    prevButton.disabled = true
                    nextButton.disabled = false
                } else if (index === slideCount - 1) {
                    prevButton.disabled = false
                    nextButton.disabled = true
                } else {
                    prevButton.disabled = false
                    nextButton.disabled = false
                }

                const correspondingButton = document.querySelector(
                    `.js-slide[data-slide="${index}"]`
                )

                correspondingButton.classList.add('-active')

                photoSliderInstance.goTo(index)
            },
        })

        slideButtons.forEach(button => {
            button.addEventListener('click', () => {
                const navIndex = button.dataset.slide * 1

                textSliderInstance.goTo(navIndex)
            })
        })

        nextButton.addEventListener('click', () => {
            textSliderInstance.next(1)
        })

        prevButton.addEventListener('click', () => {
            textSliderInstance.prev(1)
        })
    })
}
